module.exports = __webpack_public_path__ + "img/gift2.e0cc35f4.png";